import api from "@/services/api";
import { ENDPOINTS } from "@/constants/endpoints";
import url from "@/helpers/url";

export default {
  async vote(form) {
    try {
      const { data } = await api.post(
        url(ENDPOINTS.vote, { id: form.e_meeting_id }),
        form
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async MandateFilesByManager(form) {
    try {
      const participationId = form.votes[0].e_meeting_participation_id;
      const { data } = await api.post(
        url(ENDPOINTS.saveMandateFilesByManager, {
          id: form.e_meeting_id,
          participation_id: participationId,
        }),
        { mandate_users: form.mandate_users, new_mandates: form.new_mandates }
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async papervote(form) {
    try {
      const { data } = await api.post(
        url(ENDPOINTS.paper_vote, { meetingId: form.e_meeting_id }),
        form
      );
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async markVoteInvalid(meetingId, voteId, comment) {
    try {
      const { data } = await api.delete(
        url(ENDPOINTS.invalid_vote, { meetingId, voteId }),
        { data: { invalid_vote_comment: comment } }
      );
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getVotes(id, user) {
    const params = user ? { params: { user_id: user } } : {};
    try {
      const { data } = await api.get(url(ENDPOINTS.vote, { id: id }), params);
      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async deleteVoteFile(meetingId, voteId, fileId) {
    try {
      await api.delete(url(ENDPOINTS.voteFile, { meetingId, voteId, fileId }));
      return Promise.resolve();
    } catch (e) {
      await Promise.reject(e);
    }
  },
};
